import { AlertBadge, AlertBanner } from "@molecules"

function EcommerceOrderStatusBadge(props) {
    const { needs_syncing, has_sync_error, external_entity_id } = props.ecommerceSyncStatus

    if (needs_syncing) {
        return (
            <AlertBadge status="neutral" size="sm" showIcon={false} isLoading={true}>
                Sending…
            </AlertBadge>
        )
    }

    if (has_sync_error) {
        return (
            <AlertBadge status="error" size="sm" showIcon={true} isLoading={false}>
                Failed
            </AlertBadge>
        )
    }

    return (
        <AlertBadge status="success" size="sm" showIcon={true} isLoading={false}>
            {external_entity_id ? `Sent — order #${external_entity_id}` : "Sent"}
        </AlertBadge>
    )
}

export default function EcommerceOrderStatusSection(props) {
    const { ecommerceSyncStatus } = props

    if (ecommerceSyncStatus === null) {
        return null
    }

    const { has_sync_error, sync_error_details, store_name } = ecommerceSyncStatus
    const failureMessage = has_sync_error ? sync_error_details?.message : undefined

    return (
        <div className="data-panel__form__field" aria-label="Store Order">
            <span className="data-panel__form__field__label">Store Order</span>
            <div style={{ display: "flex", flexDirection: "column", gap: "var(--size-2)" }}>
                <div
                    style={{
                        display: "flex",
                        gap: "var(--size-3)",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <span style={{ fontWeight: "var(--font-weight-medium)" }}>{store_name}</span>
                    <EcommerceOrderStatusBadge ecommerceSyncStatus={ecommerceSyncStatus} />
                </div>
                {failureMessage && <AlertBanner type="card" status="error" message={failureMessage} />}
            </div>
        </div>
    )
}
